module.exports = __webpack_public_path__ + "img/939.e534f82f.png";